import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import Select from 'react-select';
import Popup from './../popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';

export class ConfigServices extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      service: null,
      newService: null,
      services: [],
      companyServices: [],
      categories: [],
      loading: true,
      errorDeletion: "",
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
    this.handleNew = this.handleNew.bind(this);
  }

  async componentDidMount() {
    await this.populateCategoriesData();
    if (this.state.companyId === 0)
      this.populateCompaniesData();
    else
      this.populateCompanyServicesData(this.state.companyId);
  }

  selectService(service, addNew) {
    var companyServices = this.state.companyServices;
    var cs = companyServices.filter(s => s.id === service.id);
    if (cs.length > 0) {
      service = cs[0];
    }
    if (!addNew && cs.length === 0) {
      this.setState(prevState => ({...prevState, newService: service, service: null}));
      return;
    }
    if (service.maxTime === undefined)
      service.maxTime = 8760;
    if (service.timeEditable === undefined)
      service.timeEditable = true;
    this.setState(prevState => ({...prevState, newService: null, service: service}));
  }

  handleNew() {
    this.setState(prevState => ({...prevState, service: { id: 0, timeEditable: true }}));
  }

  async handleSave(service) {
    if (!service.name || service.name === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/service`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(service)
    });
    const data = await response.json();
    var companyServices = this.state.companyServices;
    for (var i = 0; i < companyServices.length; i++)
    {
      if (companyServices[i].id === service.id)
      {
        companyServices[i] = service;
        break;
      }
    }
    if (i === companyServices.length)
      companyServices.push(data);
    if (!service.id)
      this.state.services.push({id: data.id, name: data.name});
    this.setState(prevState => ({...prevState, companyServices: companyServices}));
    this.selectService(data);
  }

  changeTimeEditable(service) {
    service.timeEditable = !service.timeEditable;
    this.setState(prevState => ({...prevState, service: service}));
    this.handleSave(service);
  }

  async handleDelete(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/service/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    if (!response.ok) {
      this.setState(prevState => ({...prevState, errorDeletion: "Unable to delete, possibly the service is used"}));
      return;
    }
    var companyServices = this.state.companyServices.filter(d => d.id !== id);
    if (this.state.service?.id === id)
      this.setState(prevState => ({...prevState, service: null}));
    this.setState(prevState => ({...prevState, companyServices: companyServices, errorDeletion: ""}));
  }

  selectCategory(category) {
    this.setState(prevState => ({...prevState, categoryId: category.value, selectedCategory: category}));
    this.populateServicesData(category.value);
  }

  renderServicesTable() {
    return (
      <>
          <label for="category">Фильтр по категориям</label>
          <Select
              className="formselect"
              classNamePrefix="select"
              isDisabled={false}
              isClearable={false}
              isSearchable={true}
              options={this.state.categories.filter(c => !c.parentCategoryId).map(c => ({ value: c.id, label: c.name }))}
              placeholder="Search categories..."
              noOptionsMessage={() => "No Categories Found"}
              onChange={(newValue) => this.selectCategory(newValue)}
              value={this.state.selectedCategory}
              name="category"
            />
      <div class="tabledivbig">
      <div class="tabledivbtn">

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {this.state.services.map(service =>
            <tr key={service.id} onClick={() => this.selectService(service, false)} class={this.state.service?.id === service.id || this.state.newService?.id === service.id?'react-calendar__tile--active':''}>
              <td>{service.id}</td>
              <td>{service.name}</td>
            </tr>
          )}
        </tbody>
      </table>

      </div>
        <input style={{marginTop: "5px"}} disabled={this.state.service?.id === 0} class="btn btn-primary" type="button" value="New" id="Button_New" onClick={this.handleNew}/>
        <input style={{marginTop: "5px"}} disabled={(!this.state.service && !this.state.newService) || this.state.service?.id === 0 || this.state.companyServices.filter(s => s.id === this.state.service?.id).length !== 0} class="btn btn-primary" type="button" value="Use selected" id="Button_New" onClick={() => this.selectService(this.state.newService, true)}/>
      </div>
    </>);
  }

  renderDelete(serviceId) {
    return (
      <>
      <p style={{color: "red"}}>{this.state.errorDeletion}</p>
      <div class="btndelete" onClick={() => this.handleDelete(serviceId)}>Confirm deletion</div>
      </>
    );
  }

  renderCompanyServicesTable() {
    return (
      <div class="tablediv">

        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Price</th>
              <th>MinTime</th>
              <th>MaxTime</th>
              <th>Editable</th>
              <th>Control</th>
            </tr>
          </thead>
          <tbody>
            {this.state.companyServices.map(service =>
              <tr key={service.id} onClick={() => this.selectService(service)} class={this.state.service?.id === service.id?'react-calendar__tile--active':''}>
                <td>{service.id}</td>
                <td>{service.name}</td>
                <td>{service.price}</td>
                <td>{service.minTime}</td>
                <td>{service.maxTime}</td>
                <td onClick={() => this.changeTimeEditable(service)}>{service.timeEditable ? '+' : ''}</td>
                <Popup ref={this.selectorRef}
                  className="popup-book"
                  trigger={open => <td>Delete</td>}
                  position="bottom center"
                  closeOnDocumentClick>{() => this.renderDelete(service.id)}</Popup>
              </tr>
            )}
          </tbody>
        </table>

      </div>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderServicesTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="services" />
        <h4 id="tabelLabel">Config services</h4>
        <div>All existing services list</div>
        {contents}
        <div>Company services list</div>
        {this.renderCompanyServicesTable()}

        {this.state.service === null?<></>:
        <><div class="form-group">
          <label for="Input_ServiceName">Service name</label>
          <input class="form-control" disabled={this.state.service.id} type="text" id="Input_ServiceName" name="Input.ServiceName"
            value={this.state.service.name ? this.state.service.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, name: val}}));}}/>
        </div>
        <div class="form-group">
          <label for="Input_ServiceCategory">Category</label>
          <select class="form-control" disabled={this.state.service.id} id="Input_ServiceCategory" name="Input.ServiceCategory"
            value={this.state.service.categoryId ? this.state.service.categoryId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, categoryId: val}}));}}>
            {this.state.categories.map(category =>
              <option value={category.id}>{category.name}</option>
            )}
          </select>
        </div>
        <div class="form-group">
          <label for="Input_ServicePrice">Service price</label>
          <input class="form-control" type="text" id="Input_ServicePrice" name="Input.ServicePrice"
            value={this.state.service.price !== undefined ? this.state.service.price : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, price: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMinTime">Service minimum duration in hours</label>
          <input class="form-control" type="text" id="Input_ServiceMinTime" name="Input.ServiceMinTime"
            value={this.state.service.minTime !== undefined ? this.state.service.minTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, minTime: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMaxTime">Service maximum duration in hours</label>
          <input class="form-control" type="text" id="Input_ServiceMaxTime" name="Input.ServiceMaxTime"
            value={this.state.service.maxTime !== undefined ? this.state.service.maxTime : '8760'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, maxTime: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingInterval">Service booking interval</label>
          <select class="form-control" id="Input_BookingInterval" name="Input.BookingInterval"
            value={this.state.service.bookingInterval ? this.state.service.bookingInterval.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, bookingInterval: val}}));}}>
              <option value="1">1 min</option>
              <option value="2">5 min</option>
              <option value="3">1 hour</option>
              <option value="4">1 day</option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_PartialBooking">Partial booking settings</label>
          <select class="form-control" id="Input_PartialBooking" name="Input.PartialBooking"
            value={this.state.service.partialBooking ? this.state.service.partialBooking.toString() : 'null'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, partialBooking: val === 'null' ? null : val}}));}}>
              <option value="null">Off</option>
              <option value="2">2 members</option>
              <option value="3">3 members</option>
              <option value="4">4 members</option>
              <option value="5">5 members</option>
              <option value="6">6 members</option>
              <option value="7">7 members</option>
              <option value="8">8 members</option>
              <option value="9">9 members</option>
              <option value="10">10 members</option>
          </select>
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value={this.state.service.id===0?"Create":"Save"} id="Button_Save" onClick={() => this.handleSave(this.state.service)}/>
        </>}
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
        this.setState(prevState => ({...prevState, companyId: this.state.companies[0].id}));
        this.populateCompanyServicesData(this.state.companyId);
    }
  }

  async populateServicesData(categoryId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/services?categoryId=${categoryId}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data, loading: false}));
  }

  async populateCategoriesData() {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/services/categories/0`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, categories: data}));
  }

  async populateCompanyServicesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/services`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    if (data.length > 0 && !this.state.selectedCategory && this.state.categories.filter(c => c.id === data[0].categoryId).length > 0) {
      let category = this.state.categories.filter(c => c.id === data[0].categoryId)[0];
      if (category.parentCategoryId) {
        category = this.state.categories.filter(c => c.id === category.parentCategoryId)[0];
      }
      this.setState(prevState => ({...prevState, companyServices: data, loading: false, categoryId: category.id, selectedCategory:{value:category.id, label:category.name}}));
      this.populateServicesData(category.id);
    } else {
      this.setState(prevState => ({...prevState, companyServices: data, loading: false}));
    }
  }
}
